<script>
import _debounce from 'lodash/debounce';
export default {


  props: [
    'initialSubkind',
    'initialTag',
  ],


  data: function(){
    return {

      subkind: JSON.parse(JSON.stringify(this.$props.initialSubkind)),
      tag: JSON.parse(JSON.stringify(this.$props.initialTag)),
      tagVisibleName: JSON.parse(JSON.stringify(this.$props.initialTag.name)),

      editTagRequesting: false,
      editTagSuccess: null,
      editTagError: null,

      subs: null,



      deletePhase: 0,
      deleted: 0,

      colors: [
        { key: 1, name: 'Default', },
        { key: 2, name: 'Brown', },
        { key: 3, name: 'Red', },
        { key: 4, name: 'Orange', },
        { key: 5, name: 'Green', },
        { key: 6, name: 'Teal', },
        { key: 7, name: 'Blue', },
        { key: 8, name: 'Pink', },
        { key: 9, name: 'Purple', },
      ],


      extraData: {},

    }
  },

  computed: {
    nameCharsLeft: function(){
      return this.tag.name ? (50 - this.tag.name.length) : 50;
    },
    descriptionCharsLeft: function(){
      return this.tag.description ? (300 - this.tag.description.length) : 300;
    },
  },

  created: function(){
    if (this.subkind=='subs') {
      this.getTagSubs();
    }
    this.emitTagboxHeader();
  },

  mounted: function(){
    this.getTagExtraData();
  },



  beforeDestroy: function(){
    this.cancelGetTagSubs();
  },

  watch: {
    tag: function(){
      this.resetDeleteTag();
    },
    editTagRequesting: function(){
      this.resetDeleteTag();
    },
    colors: function(){
      this.resetDeleteTag();
    },
    subkind: function(){
      this.resetDeleteTag();
      this.resetEditTagState();
    },
  },



  methods: {


    emitTagboxHeader: function(){
      if (this.deleted) {
        this.$emit('input', '');
      } else if (this.tag && this.tag.name) {
        this.$emit('input', 'Tag: ' + this.tag.name);
      }
    },


    cancelGetTagSubs: function(){
      this._getTagSubsRequest ? this._getTagSubsRequest.cancel() : null;
    },


    getTagExtraData: function(){
      this.$axios({
        url: this.$store.state.api + '/get-tag/',
        method: 'get',
        params: {
          pk: this.tag.pk,
        }
      }).then(function(response){
        this.extraData = response.data.tag ? response.data.tag : {};
      }.bind(this));

    },

    getTagSubs: function(){

      if (this.subs && this.subs.length) {
        return false;
      }

      var CancelToken = this.$axios.CancelToken;
      var source = CancelToken.source();
      this._getTagSubsRequest = source;

      this.$axios({
        cancelToken: source.token,
        url: this.$store.state.api + '/get-tag-subs/',
        method: 'get',
        params: {
          tag_slug: this.tag.slug,
          tag_owner: this.tag.owner.username,
        },
      }).then(function(response){
        this.subs = response.data.subscribers;
      }.bind(this));

    },



    editTag: /*_debounce(*/function(kind){

      this.editTagRequesting = true;
      this.editTagSuccess = null;
      this.editTagError = null;

      var data = { pk: this.tag.pk, };
      if (kind=='name') { data['name'] = this.tag.name; }
      if (kind=='description') { data['description'] = this.tag.description; }
      if (kind=='color') { data['color'] = this.tag.color; }
      //if (kind=='is_private') { data['is_private'] = this.tag.is_private; }
      if (kind=='visibility') { data['visibility'] = this.tag.visibility; }
      if (kind=='item_layout') { data['item_layout'] = this.tag.item_layout; }

      var request = this.$axios({
        url: this.$store.state.api + '/edit-tag/',
        method: 'post',
        data: data,
      }).then(function(response){
        this.editTagRequesting = false;
        this.editTagSuccess = true;
        this.updateTagData(response.data);
        this.$store.commit('deleteTrackedRequest', {id: 'editTag'});
      }.bind(this), function(error){
        this.editTagRequesting = false;
        this.editTagError = error.response.data ? error.response.data : true;
        this.$store.commit('deleteTrackedRequest', {id: 'editTag'});
      }.bind(this));

      this.$store.commit('addTrackedRequest', {id: 'editTag', request: request});
      this.emitTagboxHeader();

    }/*, 100)*/,

    //inputHandler: _debounce(function(){
    //    this.editTag('owner_notes');
    //}, 1000),



    updateTagData: function(data){

      this.tagVisibleName = data.name;
      this.tag.slug = data.slug;

      this.$store.commit('updateTag', JSON.parse(JSON.stringify(data)));

      if (this.$store.state.tagPageMeta && this.$store.state.tagPageMeta.pk === this.tag.pk) {
        this.$store.commit('updateTagPageMeta', JSON.parse(JSON.stringify(data)));
        this.$router.replace(`/${data.owner_username}/${data.slug}`);
      }

    },


    resetDeleteTag: function(){
      this.deletePhase = 0;
    },

    resetEditTagState: function(){
      this.editTagRequesting = false;
      this.editTagSuccess = null;
      this.editTagError = null;
    },


    deleteTag: function(){

      if (this.deletePhase === 0) {
        this.deletePhase = 1;
        return false;
      }

      if ( (this.deletePhase === 1) && this.extraData.subscribers_count ) {
        this.deletePhase = 2;
        return false;
      } else {
        this.deleteTagConfirmed();
        return false;
      }

      if (this.deletePhase === 2) {
        this.deleteTagConfirmed();
        return false;
      }

    },



    deleteTagConfirmed: function(){

      this.$store.dispatch('apiDeleteTag', {
        pk: this.tag.pk,
        onSuccess: function(response){
          this.tag = null;
          this.tagVisibleName = null;
          this.deleted = 1;
          this.emitTagboxHeader();
        }.bind(this),
        onError: function(error){
        }.bind(this),
      });

    },








  },


};
</script>


<template>
<div class="tagbox" >

  <div class="tagbox-inner" v-if="deleted"  ref="tagboxInner">
    <div class="tagbox-deleted">
      <div class="tagbox-deleted-icon">

        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">
          <path d="M 32.59375 4 C 31.816406 4 31.054688 4.285156 30.46875 4.875 L 3.875 31.75 C 2.707031 32.929688 2.707031 34.878906 3.875 36.0625 L 13.4375 45.71875 C 13.628906 45.902344 13.890625 46.003906 14.15625 46 L 41 46 C 41.390625 46.058594 41.78125 45.878906 41.996094 45.546875 C 42.210938 45.214844 42.210938 44.785156 41.996094 44.453125 C 41.78125 44.121094 41.390625 43.941406 41 44 L 25.03125 44 L 47.125 21.6875 C 48.292969 20.507813 48.296875 18.558594 47.125 17.375 L 34.75 4.875 C 34.164063 4.285156 33.371094 4 32.59375 4 Z M 32.59375 6 C 32.84375 6 33.113281 6.109375 33.3125 6.3125 L 45.6875 18.8125 C 45.949219 19.074219 46.015625 19.421875 45.9375 19.75 C 45.820313 19.328125 45.460938 19 45 19 C 44.449219 19 44 19.449219 44 20 C 44 20.542969 44.429688 20.984375 44.96875 21 L 43 22.96875 C 42.984375 22.429688 42.542969 22 42 22 C 41.449219 22 41 22.449219 41 23 C 41 23.542969 41.429688 23.984375 41.96875 24 L 40 26 C 40 25.449219 39.550781 25 39 25 C 38.449219 25 38 25.449219 38 26 C 38 26.550781 38.449219 27 39 27 L 37 29 C 37 28.449219 36.550781 28 36 28 C 35.449219 28 35 28.449219 35 29 C 35 29.550781 35.449219 30 36 30 C 36.023438 30 36.042969 30 36.0625 30 L 33.96875 32.09375 C 33.972656 32.058594 34 32.035156 34 32 C 34 31.449219 33.550781 31 33 31 C 32.8125 31 32.648438 31.066406 32.5 31.15625 L 30.8125 29.5625 C 30.925781 29.402344 31 29.210938 31 29 C 31 28.449219 30.550781 28 30 28 C 29.75 28 29.519531 28.097656 29.34375 28.25 L 27.71875 26.71875 C 27.898438 26.539063 28 26.277344 28 26 C 28 25.449219 27.550781 25 27 25 C 26.699219 25 26.433594 25.132813 26.25 25.34375 L 24.59375 23.78125 C 24.835938 23.597656 25 23.324219 25 23 C 25 22.449219 24.550781 22 24 22 C 23.648438 22 23.367188 22.195313 23.1875 22.46875 L 21.4375 20.875 C 21.761719 20.710938 22 20.390625 22 20 C 22 19.449219 21.550781 19 21 19 C 20.585938 19 20.246094 19.265625 20.09375 19.625 L 19.53125 19.09375 C 19.484375 19.046875 19.429688 19.003906 19.375 18.96875 L 31.90625 6.3125 C 32.105469 6.109375 32.34375 6 32.59375 6 Z M 33 7 C 32.449219 7 32 7.449219 32 8 C 32 8.550781 32.449219 9 33 9 C 33.550781 9 34 8.550781 34 8 C 34 7.449219 33.550781 7 33 7 Z M 30 10 C 29.449219 10 29 10.449219 29 11 C 29 11.550781 29.449219 12 30 12 C 30.550781 12 31 11.550781 31 11 C 31 10.449219 30.550781 10 30 10 Z M 36 10 C 35.449219 10 35 10.449219 35 11 C 35 11.550781 35.449219 12 36 12 C 36.550781 12 37 11.550781 37 11 C 37 10.449219 36.550781 10 36 10 Z M 27 13 C 26.449219 13 26 13.449219 26 14 C 26 14.550781 26.449219 15 27 15 C 27.550781 15 28 14.550781 28 14 C 28 13.449219 27.550781 13 27 13 Z M 33 13 C 32.449219 13 32 13.449219 32 14 C 32 14.550781 32.449219 15 33 15 C 33.550781 15 34 14.550781 34 14 C 34 13.449219 33.550781 13 33 13 Z M 39 13 C 38.449219 13 38 13.449219 38 14 C 38 14.550781 38.449219 15 39 15 C 39.550781 15 40 14.550781 40 14 C 40 13.449219 39.550781 13 39 13 Z M 24 16 C 23.449219 16 23 16.449219 23 17 C 23 17.550781 23.449219 18 24 18 C 24.550781 18 25 17.550781 25 17 C 25 16.449219 24.550781 16 24 16 Z M 30 16 C 29.449219 16 29 16.449219 29 17 C 29 17.550781 29.449219 18 30 18 C 30.550781 18 31 17.550781 31 17 C 31 16.449219 30.550781 16 30 16 Z M 36 16 C 35.449219 16 35 16.449219 35 17 C 35 17.550781 35.449219 18 36 18 C 36.550781 18 37 17.550781 37 17 C 37 16.449219 36.550781 16 36 16 Z M 42 16 C 41.449219 16 41 16.449219 41 17 C 41 17.550781 41.449219 18 42 18 C 42.550781 18 43 17.550781 43 17 C 43 16.449219 42.550781 16 42 16 Z M 27 19 C 26.449219 19 26 19.449219 26 20 C 26 20.550781 26.449219 21 27 21 C 27.550781 21 28 20.550781 28 20 C 28 19.449219 27.550781 19 27 19 Z M 33 19 C 32.449219 19 32 19.449219 32 20 C 32 20.550781 32.449219 21 33 21 C 33.550781 21 34 20.550781 34 20 C 34 19.449219 33.550781 19 33 19 Z M 39 19 C 38.449219 19 38 19.449219 38 20 C 38 20.550781 38.449219 21 39 21 C 39.550781 21 40 20.550781 40 20 C 40 19.449219 39.550781 19 39 19 Z M 17.96875 20.40625 C 18.023438 20.476563 18.085938 20.539063 18.15625 20.59375 L 32.34375 33.75 L 22.1875 44 L 14.59375 44 L 5.3125 34.625 C 4.910156 34.21875 4.914063 33.589844 5.3125 33.1875 Z M 30 22 C 29.449219 22 29 22.449219 29 23 C 29 23.550781 29.449219 24 30 24 C 30.550781 24 31 23.550781 31 23 C 31 22.449219 30.550781 22 30 22 Z M 36 22 C 35.449219 22 35 22.449219 35 23 C 35 23.550781 35.449219 24 36 24 C 36.550781 24 37 23.550781 37 23 C 37 22.449219 36.550781 22 36 22 Z M 33 25 C 32.449219 25 32 25.449219 32 26 C 32 26.550781 32.449219 27 33 27 C 33.550781 27 34 26.550781 34 26 C 34 25.449219 33.550781 25 33 25 Z ">
          </path>
        </svg>

      </div>
      <div class="tagbox-deleted-text">Tag was deleted</div>
    </div>
  </div>


  <div class="tagbox-inner" v-else   ref="tagboxInner">



    <div class="tagbox-header">

      <button type="button" class="tagbox-title  mod-edit" :class="{'mod-active': subkind=='edit'}"
      @click.prevent="subkind='edit'">
        Edit

        <div class="tagbox-title-status" :class="{'mod-requesting': editTagRequesting, 'mod-finished': editTagError || editTagSuccess}">
          <spinner v-if="editTagRequesting" kind="circle" dark="true" size="1"></spinner>
          <span v-if="editTagSuccess"
          v-tooltip="'Successfully updated'">✓</span>
          <span v-if="editTagError"
          v-tooltip="'There was an error while updating'">✖</span>
        </div>
      </button>

      <button type="button" class="tagbox-title" :class="{'mod-active': subkind=='details'}"
      @click.prevent="subkind='details'">Details
      </button>

      <button type="button" class="tagbox-title" :class="{'mod-active': subkind=='subs'}"
      @click.prevent="subkind='subs'; getTagSubs();">Subscribers ({{extraData.subscribers_count}})
      </button>


    </div>


    <!-- <div class="tagbox-spacer  mod-header"></div> -->




    <div class="tagbox-content">









      <div v-if="subkind=='edit'">





        <!-- Category -->
        <!--
        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">Tag Category</div>
          <button type="button" class="tagbox-sublabel">Edit Categories</button>
        </div>

        <div class="tagbox-select-wrapper mod-category">
          <select class="tagbox-select">
            <option value="b">General</option>
            <option value="a">Design</option>
            <option value="a">Web Development</option>
          </select>
        </div> -->




        <!-- Name -->
        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">Tag Name</div>
          <div class="tagbox-sublabel">{{nameCharsLeft}}</div>
        </div>

        <div class="tagbox-textarea-wrapper  mod-name">
        <textarea v-autosize rows="1" maxlength="50" class="tagbox-textarea" v-model="tag.name"
        @change="editTag('name')" @keydown.prevent.enter  @keyup.prevent.enter="editTag('name')"></textarea>
        </div>




        <!-- Description -->
        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">
            Tag Description
            <span v-tooltip="'You can use this field to comment this tag for yourself or to describe it to other users. It will be visible in tag page, profile page and also in discover page if the tag is public.'">(?)</span>
          </div>
          <div class="tagbox-sublabel">
            {{descriptionCharsLeft}}
          </div>
        </div>

        <div class="tagbox-textarea-wrapper">
        <textarea v-autosize rows="2" maxlength="300" class="tagbox-textarea" v-model="tag.description" @change="editTag('description')" @keydown.prevent.enter  @keyup.prevent.enter="editTag('description')">
        </textarea>
        </div>




        <!-- Color -->
        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">Tag Color</div>
          <!-- <div class="tagbox-sublabel"></div> -->
        </div>


        <div class="tagbox-colors-wrapper">

          <div class="tagbox-color-input" v-for="c in colors" v-tooltip="c.name">
            <input  :id="'tagboxcolor-'+c.key" type="radio" name="color" :value="c.key" v-model="tag.color" @change="editTag('color')">
            <label :for="'tagboxcolor-'+c.key"></label>
          </div>

        </div>






        <!-- Visibility -->
        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">Visibility</div>
          <!-- <div class="tagbox-sublabel"></div> -->
        </div>



        <div class="tagbox-visiblity-inputs-wrapper">


          <div class="tagbox-input-check-wrapper mod-radio  mod-inline  mod-visibility-private">
            <div class="tagbox-input-check mod-radio  mod-inline">

              <input  id="visibility-private" name="visibility" type="radio" v-model="tag.visibility" @change="editTag('visibility')" value="1">
              <label for="visibility-private"><div class="text">Private</div></label>

            </div>
          </div>



          <div class="tagbox-input-check-wrapper mod-radio  mod-inline  mod-visibility-url">
            <div class="tagbox-input-check mod-radio  mod-inline">

              <input  id="visibility-url" name="visibility" type="radio" v-model="tag.visibility" @change="editTag('visibility')" value="2">
              <label for="visibility-url"><div class="text">Unlisted</div></label>

            </div>
          </div>



          <div v-if="$store.state.user.can_publish_tags" class="tagbox-input-check-wrapper mod-radio  mod-inline  mod-visibility-public">
            <div class="tagbox-input-check mod-radio  mod-inline">

              <input  id="visibility-public" name="visibility" type="radio" v-model="tag.visibility" @change="editTag('visibility')" value="3">
              <label for="visibility-public"><div class="text">Public</div></label>

              <!--v-model="tag.is_private" :disabled="!tag.owner.is_premium"  -->
              <!--
              <a :href="$store.state.urls.pricing" class="stag-edit__only-pro" v-if="!tag.owner.is_premium"
              >Pro Feature
              </a> -->

            </div>
          </div>


          <div v-else class="tagbox-input-check-wrapper mod-radio  mod-inline  mod-visibility-public">
            <div class="tagbox-input-check mod-radio  mod-inline">

              <input  id="visibility-public" name="INVITEONLY" type="button" value="INVITEONLY" @click="$store.commit('publishInviteModal', 1)">
              <label for="visibility-public"><div class="text">Public</div></label>


            </div>
          </div>

        </div>



        <div class="tagbox-tip-visiblity">

          <div v-if="tag.visibility==1" class="tagbox-tip">

            <strong>Private Tag</strong>
            <br>It's hidden &amp; inaccessible for everyone.
            <br>It's not possible to subscribe to this tag.
            <br>It's also hidden for existing subscribers.
          </div>

          <div v-if="tag.visibility==2" class="tagbox-tip">

            <strong>Unlisted Tag</strong>
            <br>Only users that know this tag URL can see &amp; access it.
            <br>It's possible to subscribe to this tag.
            <br>Existing subscribers can see & access it.
          </div>


          <div v-if="tag.visibility==3" class="tagbox-tip">

            <strong>Public Tag</strong>
            <br>All users can see &amp; access it in any place.
            <br>It's possible to subscribe to this tag.
          </div>

        </div>






        <!--
        <div class="tagbox-spacer"></div> -->






        <!--  <div class="tagbox-label-wrapper">
          <div class="tagbox-label">Delete</div>
          <div class="tagbox-sublabel"></div>
        </div>-->

        <div class="tagbox-delete-wrapper">

          <button type="button" @click.prevent="deleteTag" class="tagbox-delete-btn" v-tooltip="'Deleting this tag won\'t delete any bookmarks assigned to it.'" @mouseleave="resetDeleteTag">
          <template v-if="deletePhase===0">Delete This Tag</template>
          <template v-if="deletePhase===1">Click again to confirm</template>
          <template v-if="deletePhase===2">This tag has {{extraData.subscribers_count}} subscriber{{extraData.subscribers_count===1 ? '' : 's'}}. Are you really sure you want to delete it?</template>
          </button>

        </div>



        <div v-if="editTagError" class="tagbox-error-wrapper">
          {{editTagError}}
        </div>


      </div>






      <div v-if="subkind=='details'">


        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">
            Full URL Address
          </div>
          <div class="tagbox-sublabel"></div>
        </div>
        <div class="tagbox-detail-content"><router-link @click.native="$store.commit('eventCloseDialogbox')" :to="'/'+tag.owner.username+'/'+tag.slug">
        <strong>{{$store.state.webapp}}/{{tag.owner.username}}/{{tag.slug}}</strong></router-link></div>



        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">Created</div>
          <div class="tagbox-sublabel"></div>
        </div>
        <div class="tagbox-detail-content">
          <span>
            <strong>{{tag.date_created|dfFormatC}}</strong> ({{tag.date_created|dfFormatDistanceFromNow}})
          </span>
        </div>



        <!--
        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">Updated</div>
          <div class="tagbox-sublabel"></div>
        </div>
        <div class="tagbox-detail-content">
          <span>
          <strong>{{tag.date_updated|dfFormatC}}</strong> ({{tag.date_updated|dfFormatDistanceFromNow}})
          </span>
        </div> -->



        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">
            Links
          </div>
          <div class="tagbox-sublabel"></div>
        </div>
        <div class="tagbox-detail-content"><strong>{{extraData.items_count}} links</strong></div>





        <div class="tagbox-label-wrapper">
          <div class="tagbox-label">
            Views <span v-tooltip="'Number of times this tag was viewed by other people.'">(?)</span>
          </div>
          <div class="tagbox-sublabel"></div>
        </div>
        <div class="tagbox-detail-content"><strong>{{tag.page_views}} views</strong></div>





      </div>





      <div class="tagbox-content-subs" v-if="subkind=='subs'">


        <div class="tagbox-tip-visiblity">

          <div v-if="tag.visibility==1" class="tagbox-tip mod-in-subs-tab">

            <strong>Private Tag</strong>
            <br>It's hidden &amp; inaccessible for everyone.
            <br>It's not possible to subscribe to this tag.
            <br>It's also hidden for existing subscribers.
          </div>

          <div v-if="tag.visibility==2" class="tagbox-tip mod-in-subs-tab">

            <strong>Unlisted Tag</strong>
            <br>Only users that know this tag URL can see &amp; access it.
            <br>It's possible to subscribe to this tag.
            <br>Existing subscribers can see & access it.
          </div>


        </div>



        <div class="tagbox-label-wrapper  mod-subs">
          <div class="tagbox-label">Subscribers</div>
          <div class="tagbox-sublabel"></div>
        </div>


        <spinner kind="dots" dark="true" v-if="!subs"></spinner>

        <div class="tagbox-subs-wrapper">

          <router-link v-if="subs && subs.length" class="tagbox-sub" v-for="sub in subs" :to="'/'+sub.username" :key="'tagboxsub'+sub.pk" @click.native="$store.commit('eventCloseDialogbox')">
            <div class="tagbox-sub-profile-img">
              <img v-if="sub.profile_image" :src="sub.profile_image">
            </div>
            <div class="tagbox-sub-username">{{sub.username}}</div>
          </router-link>

        </div>



        <div v-if="subs && (!subs.length)">
          No subscribers...
        </div>

      </div>





    </div>



  </div>
</div>
</template>


<style lang="scss" scoped>

  @import "../../../common/style/_variables.scss";


  .tagbox {
    background-color: lighten(#eee,4);
    border-radius: 6px;
    width: 100vw;
    width: calc(100vw - 40px);
     // border: 1px solid darken(#eee,1);
    max-width: 400px;
    //min-height: 600px;
    //box-shadow: 0 2px 25px rgba(black,.05);
    //border: 1px solid darken(white,10);
    //box-shadow: 0 2px 5px -1px rgba(black,.05);
    box-shadow: 0 2px 5px 0 rgba(black, .03), 0 2px 30px 5px rgba(black, .02);
    overflow: hidden;

    html.mod-transitions-enabled & {
      transition: height 200ms ease-in-out;
    }

    transform: rotate3d(0,0,0,0);
    backface-visibility: hidden;
  }


  .tagbox-inner {
  }


  .tagbox-content {
    padding: 0 25px 20px 25px;
  }

  .tagbox-content-subs {
    padding-top: 0;
  }

  .tagbox-deleted {
    padding: 25px 20px 25px 20px;
    display: block;
    text-align: center;
  }
  .tagbox-deleted-icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
    font-size: 40px;
    & svg path {
      width: 50px;
      height: 50px;
      fill: darken(white,90);
    }
    opacity: .8;
  }
  .tagbox-deleted-text {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    color: #777;
  }

  .tagbox-header {
     //margin-bottom: 20px;
    text-align: left;
    //padding: 0 5px;
    font-size: 0;
    border-bottom: 1px solid lighten(#eee,1);
  }

  .tagbox-title {
    display: inline-block;
    outline: none;
    font-size: 17px;
    color: rgba(black,.3);
    font-weight: 600;
    padding-top: 20px;
    padding-bottom: 15px;

    border-right: 1px solid lighten(#eee,1);
    padding-left: 25px;
    padding-right: 25px;

    &:last-of-type {
      border-right: none;
      padding-right: 0;
      margin-right: 0;
    }

    &.mod-active {
      color: rgba($clr-ggather,.9);
      font-weight: 600;
      cursor: default;
    }

    &.mod-edit {
      padding-right: 13px;
    }

  }




  @keyframes tagbox-title-status-anim {
    0% {
      transform: scale(1.5);
      //box-shadow: 0 0 15px 0 rgba(black,.2);
    }

    50% {
      transform: scale(0.4);
    }

    100% {
      transform: scale(1);
      //box-shadow: 0 0 0px 0 rgba(black,.0);
    }
  }


  .tagbox-title-status {
    width: 12px;
    display: inline-block;

    &.mod-requesting {
      html.mod-transitions-enabled & {
        transition: transform 50ms ease-out;
      }
      transform: scale(1.5);
      z-index: 100;

    }

    &.mod-finished {
      animation-name: tagbox-title-status-anim;
      animation-duration: 200ms;
    }

  }

  /*
  .tagbox-spacer {
    display: block;
    width: auto;
    height: 1px;
    background-color: #eee;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  */

  .tagbox-title2 {
    display: block;
    outline: none;
    font-size: 18px;
    color: rgba(black,.3);
    font-weight: 500;

    & > strong {
      color: rgba(black,.6);
    }

  }


  .tagbox-label-wrapper {
    margin-top: 30px;
    display: block;
    display: flex;
    justify-content: space-between;

    //&.mod-subs {
    //    margin-top: 20px;
    //}
  }
  .tagbox-label {
    font-size: 12px;
    opacity: .6;
  }
  .tagbox-sublabel {
    font-size: 12px;
    opacity: .5;
  }







  .tagbox-category-wrapper {

  }

    .tagbox-category {
      font-size: 14px;
      background-color: rgba(black,.05);
      border: 1px solid rgba(black,.05);
      display: block;
      width: 100%;
      text-align: left;
      color: #333;
      font-weight: 500;
      padding: 3px 6px;
      margin: 5px 0;
      outline: none;
    }



    .tagbox-new-category {
      display: block;

    }

      .tagbox-new-category-input {
        width: 100%;
        font-size: 14px;
        background-color: rgba(black,.05);
        border: 1px solid rgba(black,.05);
        display: block;
        color: #333;
        padding: 3px 6px;
        margin: 5px 0;
        font-weight: 500;
        outline: none;

      }






  .tagbox-visiblity-inputs-wrapper {
    margin-top: 5px;
    font-size: 0;
  }



  .tagbox-input-check-wrapper {
    //border: 1px solid rgba(black,.21);
    font-size: 15px;
    padding: 0;
    font-weight: 500;
    //border-radius: 3px;


    &.mod-inline {
      display: inline-block;
      margin-right: 5px;
    }
  }


    .tagbox-input-check {

      position: relative;
      padding: 2px 5px;

      input {
        cursor: pointer;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
      }

      label {
        color: rgba(black,.7);
        cursor: pointer;
        user-select: none;

        //background
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          top: 0px;
          left: 0;
          bottom: 0;
          //left: 1px;
          right: 0;

          //width: 17px;
          //height: 17px;
          background: white;
          border: 1px solid darken(#eee,5);
          border-radius: 3px;
          html.mod-transitions-enabled & {
            transition: background-color 80ms ease-out, border-color 80ms ease-out;
          }
        }


        & > .text {
          font-size: 12px;
          font-weight: 400;
          vertical-align: middle;
          display: inline-block;
          position: relative;
          z-index: 10;
          padding-right: 5px;
          padding-left: 5px;
        }
      }


      &.mod-radio label::before {
        border-radius: 3px;
      }



      label:hover,
      input:hover + label {
        &::before {
          background: lighten(#eee,5);
        }
        &::after {
          opacity: .9;
        }
        & > .text {
          color: #222;
        }
      }


      input:checked + label {

        &::before {
          background: rgba(#111,.8);
          border: 1px solid black;
        }

        &::after {
          opacity: 1;
          color: rgba(white,.9);
        }

        & > .text {
          color: rgba(white,.9);
          font-weight: 600;
        }

      }


      input:disabled + label {
        cursor: default;
        opacity: .5;
      }

    }


    .tagbox-select-wrapper {
      display: block;
    }

      .tagbox-select {
        display: inline-block;
        font-size: 13px;
        font-weight: 400;
        width: 100%;
        min-width: 200px;
        color: rgba(black,.9);
        padding: 4px 7px;
        appearance: menulist;
        border-radius: 3px;
        background-color: rgba(white,.4);
        border: 1px solid darken(#eee,5);
        outline: none;
        cursor: pointer;
        html.mod-transitions-enabled & {
          transition: color 80ms ease-out, border-color 80ms ease-out;
        }
        &:focus {
          background-color: rgba(white,.6);
          border-color: darken(#eee,15);
        }
      }



    .tagbox-textarea-wrapper {
      display: block;
      width: auto;
    }

    .tagbox-textarea {
      display: block;
      width: 100%;
      padding: 5px 8px;
      resize: none;
      background-color: rgba(white,.4);
      border: 1px solid darken(#eee,5);
      border-radius: 3px;
      line-height: 1.2;
      outline: none;

      html.mod-transitions-enabled & {
        transition: color 80ms ease-out, border-color 80ms ease-out;
      }

      &:focus {
        //background-color: rgba(black,.08);
        background-color: rgba(white,.6);
        border-color: darken(#eee,15);
      }

      .tagbox-textarea-wrapper.mod-name & {
        padding: 5px 8px;
        font-size: 17px;
      }
    }






    .tagbox-delete-wrapper {
      display: block;
      width: auto;
      text-align: right;
      margin-top: 40px;
    }

    .tagbox-delete-btn {
      padding: 3px 6px;
      font-size: 14px;
      border-radius: 3px;
      text-align: left;
      html.mod-transitions-enabled & {
        transition: background-color 130ms ease-out, border-color 130ms ease-out, color 130ms ease-out;
      }


      background-color: white;
      border: 1px solid darken(#eee,5);

      outline-color: $clr-red-500;

      &:hover {
        //background-color: $clr-red-100;
        //border: 1px solid $clr-red-200;
        color: $clr-red-900;
        background-color: darken($clr-red-100,3);
        border-color: $clr-red-300;
      }
    }




  .tagbox-colors-wrapper {
    //background: rgba(white,.8);
    border: 1px solid rgba(white,.21);
    background-color: rgba(white,.4);
    display: block;
    border-radius: 3px;
    color: #333;
    padding: 8px 10px 8px 10px;
    //background-color: #eee;
    border: 1px solid darken(#eee, 5);
    font-size: 0;
    //border-bottom: none;

    display: flex;
    justify-content: flex-start;
  }

    .tagbox-color-input {

      display: inline-block;
      margin-right: 8px;

      & > input {
        cursor: pointer;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
      }

      & > label {
        width: 18px;
        height: 18px;
        border-radius: 20px;
        display: block;
        cursor: pointer;
        text-align: center;
        border: 1px solid rgba(black, 0.1);

        &::before {
          //@include ggather-font;
          line-height: 16px;
          font-size: 8px;
          content: "";
          display: block;
          background: white;
          border-radius: 20px;
          width: 6px;
          height: 6px;
          margin: 0 auto;
          margin-top: 5px;
          color: white;
          opacity: 0;
          html.mod-transitions-enabled & {
            transition: opacity 100ms ease-out;
          }
        }

        &[for="tagboxcolor-1"] { background-color: $clr-tag-1; }
        &[for="tagboxcolor-2"] { background-color: $clr-tag-2; }
        &[for="tagboxcolor-3"] { background-color: $clr-tag-3; }
        &[for="tagboxcolor-4"] { background-color: $clr-tag-4; }
        &[for="tagboxcolor-5"] { background-color: $clr-tag-5; }
        &[for="tagboxcolor-6"] { background-color: $clr-tag-6; }
        &[for="tagboxcolor-7"] { background-color: $clr-tag-7; }
        &[for="tagboxcolor-8"] { background-color: $clr-tag-8; }
        &[for="tagboxcolor-9"] { background-color: $clr-tag-9; }

      }



      input:checked + label {
        &::before {
          opacity: .8;
        }
      }

    }





  .tagbox-detail-content {
    //background-color: #eee;
    display: inline-block;
    border-bottom: 1px solid darken(#eee,3);
    padding: 2px 0;
    border-radius: 3px;
    font-size: 15px;
    line-height: 1.2;

    strong {
      font-weight: 600;
    }
  }



  .tagbox-error-wrapper {
    margin-top: 20px;
    background-color: $clr-red-200;
    color: $clr-red-800;
    padding: 5px 10px;
    border-radius: 3px;
  }





  .tagbox-subs-wrapper {
  }

  .tagbox-sub {
    display: block;
    margin: 5px 0;
  }

    .tagbox-sub-profile-img {
      display: inline-block;
      width: 30px;
      height: 30px;
      overflow: hidden;
      vertical-align: middle;
      background-color: #eee;
      border-radius: 50px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50px;
      }
    }

    .tagbox-sub-username {
      font-size: 14px;
      display: inline-block;
      font-weight: 600;
      vertical-align: middle;
      margin-left: 5px;
    }



  .tagbox-tip-visiblity {
    display: block;
    margin-top: 5px;
  }

  .tagbox-tip {
    border: 1px solid rgba(black,.05);
    border-radius: 3px;
    max-width: 500px;
    display: block;
    margin: 0 auto 0 auto;
    margin-bottom: 30px;
    font-size: 12px;
    padding: 5px 10px;
    background-color: rgba(black,.02);

    &.mod-in-subs-tab {
      margin-bottom: 0;
      margin-top: 25px;
    }
  }




  .tagbox-spacer {
    margin-top: 20px;
    margin-bottom: 50px;
    position: relative;
    display: block;
    &::before {
      content: '';
      position: absolute;
      background-color: lighten(#eee,1);
      bottom: 0;
      left: -25px;
      right: -25px;
      height: 1px;
    }

    &.mod-header {
      margin-bottom: 20px;
      margin-top: 0;
    }
  }

</style>






<style lang="scss">
@import "../common/style/_variables.scss";
html.mod-app-theme-dark.mod-app-theme-dark.mod-app-theme-dark {

  .tagbox {
    background-color: darken(white,80);
    border-color: darken(white,70);
    color: rgba(white,.9);
  }

  .tagbox-title {
    color: rgba(white,.3);
    border-color: darken(white,74);

    &.mod-active {
      color: rgba(white,.9);
    }
  }

  .tagbox-header {
    border-color: darken(white,74);
  }

  .tagbox-label {
    color: rgba(white,.8);
  }

  .tagbox-sublabel {
    color: rgba(white,.5);
  }

  .tagbox-detail-content {
    color: rgba(white,.8);
    border-color: darken(white,70);
  }

  .tagbox-tip {
    border-color: darken(white,70);
  }



  .tagbox-deleted-icon {
    & svg path {
      fill: darken(white,20);
    }
  }

  .tagbox-delete-btn {
    background-color: darken(white,70);
    border-color: darken(white,60);
    outline-color: $clr-red-500;

    &:hover {
      color: $clr-red-900;
      background-color: darken($clr-red-100,3);
      border-color: $clr-red-300;
    }
  }

  .tagbox-colors-wrapper {
    background-color: darken(white,70);
    border-color: darken(white,60);
  }


  .tagbox-textarea {
    background-color: darken(white,70);
    border-color: darken(white,60);

    &:focus {
      background-color: darken(white,70);
      border-color: darken(white,60);
    }
  }












  .tagbox-input-check {

    label {
      color: rgba(white,.7);

      //background
      &::before {
        background-color: darken(white,70);
        border-color: darken(white,60);
      }

    }


    label:hover,
    input:hover + label {
      &::before {
        background-color: darken(white,70);
      }
      & > .text {
        color: white;
      }
    }

    input:checked + label {

      &::before {
        background-color: darken(white,55);
        border-color: darken(white,45);
      }

      &::after {
        color: rgba(white,.9);
      }

      & > .text {
        color: rgba(white,.9);
      }

    }











  }







}
</style>
